import _isNil from 'lodash/isNil';
import { WorkbenchType } from './Interfaces';

export function getWorkbenchName(wb: WorkbenchType): string {
    switch (wb) {
        case WorkbenchType.QC:
            return 'Quality Control';
    }
}

export function getAllWorkbenches() {
    return Object.entries(WorkbenchType)
        .map((entry) => parseInt(entry[0]))
        .filter((key) => !isNaN(key));
}
